const NewHeroCarouselSlideFive = () => {
  return <div className='carousel__slide-box carousel__box-five'></div>;
};

export default NewHeroCarouselSlideFive;
